import React from 'react';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { useStyles } from '../styles';
import PatientTableRow from './PatientTableRow';


const IndividualPatientResultTable = ({
  customers,
  sortDirection,
  setSortDirection,
  sortField,
  setSortField,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  customersTotalCount,
  handleCloseModal
}) => {
  const classes = useStyles();

  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = sortField === property && sortDirection === 'desc';
    setSortDirection(isDesc ? 'asc' : 'desc');
    setSortField(property);
  };

  return (
    <div className="w-full">
      <TableContainer className={classes.tableContainer}>
        <div className="mx-8 mt-4">
          <Table
            className={classes.tableAutoLayout}
            aria-label="collapsible table"
          >
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={sortField === 'firstname' || sortField === 'lastname'}
                    direction={sortDirection}
                    onClick={(event) => handleRequestSort(event, 'firstname')}
                    IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                  >
                    Name
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={sortField === 'email'}
                    IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                    onClick={(event) => handleRequestSort(event, 'email')}
                  >
                    Email
                  </TableSortLabel>
                </TableCell>
                {isCustomer3 &&
                  <TableCell>
                    <TableSortLabel
                      active={sortField === 'practice_name'}
                      IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                      onClick={(event) => handleRequestSort(event, 'practice_name')}
                    >
                      Company/Practice Name
                    </TableSortLabel>
                  </TableCell>
                }
                <TableCell>
                  <TableSortLabel
                    active={sortField === 'phone'}
                    IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                    onClick={(event) => handleRequestSort(event, 'phone')}
                  >
                    Phone
                  </TableSortLabel>
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {!!customers.length &&
                customers.map((customer) => (
                  <PatientTableRow
                    key={customer.id}
                    isCustomer3={isCustomer3}
                    customer={customer}
                    handleCloseModal={handleCloseModal}
                  />
                ))
              }
            </TableBody>
          </Table>
        </div>
        {!!customersTotalCount &&
        <TablePagination
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          component="div"
          className={classes.paginationContainer}
          count={customersTotalCount}
          rowsPerPage={rowsPerPage}
          page={currentPage - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        }
      </TableContainer>
    </div>
  );
};

export default IndividualPatientResultTable;
